import { gidToId } from '@shared/shop-api/core/helper'
import type { CustomerAddress } from '@shared/types/customer/graphql'
import type {
  CartDeliveryAddressFragment,
  CartSelectableAddressFragment,
  CountryCode,
} from '@shared/types/storefront/graphql'

export const toPartialAddress = (
  address: CartDeliveryAddressFragment | undefined
) => {
  return {
    address1: address?.address1 ?? undefined,
    city: address?.city ?? undefined,
    country: address?.formatted[address.formatted.length - 1] ?? undefined,
    firstName: address?.firstName ?? undefined,
    lastName: address?.lastName ?? undefined,
    iso2Code: (address?.countryCode as CountryCode) ?? undefined,
    zipCode: address?.zip ?? undefined,
    phone: address?.phone ?? undefined,

    /**
     * @deprecated removed without replacement
     */
    type: 'addresses',
    /**
     * @deprecated removed without replacement
     */
    salutation: undefined,
    /**
     * @deprecated removed without replacement
     */
    links: undefined,
    /**
     * @deprecated removed without replacement
     */
    isDefaultBilling: undefined,
    /**
     * @deprecated removed without replacement
     */
    isDefaultShipping: undefined,
    /**
     * @deprecated removed without replacement
     */
    id: undefined,
    /**
     * @deprecated removed without replacement
     */
    address3: undefined,
    /**
     * @deprecated removed without replacement
     */
    company: undefined,
    /**
     * @deprecated removed without replacement, use parent email instead
     */
    email: undefined,
  }
}

export const toCartAddress = (cartAddress: CartSelectableAddressFragment) => {
  return {
    id: gidToId(cartAddress.id),
    oneTimeUse: cartAddress.oneTimeUse ?? undefined,
    selected: cartAddress.selected ?? false,
    address: toPartialAddress(
      cartAddress.address as CartDeliveryAddressFragment | undefined
    ),
  }
}

export const toCustomerOrderAddress = (
  address: CustomerAddress | undefined
) => {
  return {
    type: 'addresses',
    address1: address?.address1 ?? undefined,
    city: address?.city ?? undefined,
    country: address?.formatted[address.formatted.length - 1] ?? undefined,
    firstName: address?.firstName ?? undefined,
    lastName: address?.lastName ?? undefined,
    iso2Code: address?.territoryCode ?? undefined,
    zipCode: address?.zip ?? undefined,
    phone: address?.phoneNumber ?? undefined,
    /** @deprecated removed without replacement */
    fkCountry: undefined,
    /** @deprecated removed without replacement */
    isDefaultBilling: undefined,
    /** @deprecated removed without replacement */
    isDefaultShipping: undefined,
  }
}
